import { useContext } from "react";
import { useCurrentUserQuery } from "../../hooks/useCurrentUserQuery";
import { ShowStaffViewContext } from "../App/ShowStaffViewContext";

function useShouldShowStaffView() {
  const showStaffView = useContext(ShowStaffViewContext);
  const { currentUser, isLoading } = useCurrentUserQuery();

  return {
    shouldShowStaffView: !!showStaffView && !!currentUser?.is_staff,
    isLoading
  };
}

export { useShouldShowStaffView };
